import type {LoaderFunctionArgs} from 'react-router';
import {redirect} from 'react-router';

import {getInstance} from '../../../../../helpers/axios-helper';
import type {Environment} from '../../../../../helpers/session';
import {getEnvironment, isLoggedIn} from '../../../../../helpers/session';
import type {User} from '../../../../../types/user';

export type LoginLoaderData = {
    /** not awaited: the login page shows its loading screen until they are there */
    users: Promise<User[]>;
    /** the environment the users come from */
    environment: Environment;
};

/**
 * The warehouse users to log in as. An environment switch sends the user to `/login` again, which runs this loader
 * again (a navigation to the current URL revalidates) for the users of the new environment.
 */
export const loginLoader = ({request}: LoaderFunctionArgs): LoginLoaderData | Response => {
    if (isLoggedIn()) {
        return redirect('/terminal');
    }

    const environment = getEnvironment();
    const users = getInstance(environment)
        .get<User[]>('/api/users?type=warehouse', {signal: request.signal})
        .then(response => response.data);

    // the login page handles a failure; when it was left before the users came, nobody does: not an unhandled rejection
    users.catch(() => undefined);

    return {users, environment};
};
